import axios from 'axios';
import {
    PaymentCard,
    PaymentCardListResult
} from '../models/payment-card';
import { ServiceResult } from '../models/service-result';

export const getPublicKeyAsync = async (): Promise<string> => {
    const response = await axios.get('/api/payment-gateway/public-key');
    return response.data;
};

export const chargeAsync = async (
    amount: number,
    appointmentId?: number
): Promise<string> => {
    const response = await axios.post(
        '/api/payment-gateway/charge',
        {
            amount,
            appointmentId
        }
    );
    return response.data;
};

export const getPaymentCardsAsync = async (): Promise<PaymentCard[]> => {
    const response = await axios.get('/api/payment-gateway/payment-card');
    return response.data;
};

export const saveCardAsync = async (
    token: string
): Promise<ServiceResult<PaymentCard[]>> => {
    const response = await axios.post(
        '/api/payment-gateway/save-card',
        { token }
    );
    return response.data;
};

export const updatePrimaryCardAsync = async (cardId: string): Promise<PaymentCardListResult> => {
    const response = await axios.post(
        '/api/payment-gateway/update-primary-card',
        { cardId }
    );
    return response.data;
};
